import { registerOptionsSchema as We, resetPasswordOptionsSchema as Ve, updateCustomerOptionsSchema as He, centraSubscribeToBackInStockOptionsSchema as Ke, shippingMethodModelSchema as $e, centraCheckoutApiProductSchema as Qe, centraCheckoutApiBundleProductSchema as Ye, centraSubscribeToNewsletterOptionsSchema as Je, centraGetProductsPayloadSchema as Ze } from "@made-people/centra-checkout-api";
import { jsx as c, jsxs as k, Fragment as I } from "react/jsx-runtime";
import { AutoCompleteProvider as Xe, useGlobalSearchSettings as K, emptySearchResult as de, useCurrentPaginationPage as et, CachedSearchResultsProvider as tt } from "@made-people/grease-search";
import { createContext as O, useContext as T, useState as y, useEffect as E, useMemo as D, Children as nt, useCallback as he, useRef as G, useReducer as rt } from "react";
import { z as d } from "zod";
import { CartProvider as ot, useCartMethod as it } from "@made-people/grease-cart";
import { withManagedProps as S } from "@made-people/managed-props";
import { withZod as g } from "@made-people/react-prop-guard";
import { useEffectOnce as M } from "@made-people/react-use-effect-once";
import { useCheckoutEventEmitter as j, checkoutEventEmitter as st, CheckoutEventEmitterContext as at } from "@made-people/grease-checkout";
import { isEmailAddress as ie } from "@made-people/types-email-address";
import { useOrderEventAdditionalData as ct, orderEventEmitter as ut } from "@made-people/grease-order";
import { isNotUndefined as q, isArray as me } from "@made-people/typeguards-common";
async function lt(e, t, n, r) {
  if (!t.email || !t.password)
    throw new Error("Email and password are required");
  const { success: o, error: i } = await e.login(
    t.email,
    t.password
  );
  return o ? (r == null || r(o), o.loggedIn ? {
    customer: n(o.loggedIn)
  } : (console.warn(
    "Unexpected response from Centra login, user could not be logged in"
  ), {
    customer: void 0
  })) : {
    customer: void 0
  };
}
async function dt(e, t, n, r) {
  const { email: o, password: i, firstName: s, lastName: a, attributes: u } = t, l = {
    email: o,
    password: i,
    firstName: s,
    lastName: a,
    ...u
  }, h = We.safeParse(l);
  if (!h.success)
    throw new Error(h.error.errors.toString());
  const { success: m, error: f } = await e.register(h.data);
  if (m) {
    if (r == null || r(m), !m.loggedIn)
      throw new Error("Unexpected response from register");
    return {
      success: !0,
      data: { customer: n(m.loggedIn) }
    };
  } else {
    if (Object.values(f.errors).includes("already registered"))
      return {
        success: !1,
        error: "Account_EmailAlreadyExists"
      };
    throw f;
  }
}
async function ht(e, t) {
  const { success: n, error: r } = await e.getCustomerOrders();
  if (n) {
    const o = [];
    return await Promise.all(
      n.orders.map(async (i) => {
        const s = i.items.filter((u) => !!u.bundle).map((u) => u.product.product), a = [];
        if (s.length > 0) {
          const u = await Promise.all(
            s.map(
              async (l) => await e.getBundle({ id: l })
            )
          );
          for (const l of u)
            l.success && a.push(l.success);
        }
        o.push(t(i, a));
      })
    ), {
      orders: o
    };
  } else
    return {
      orders: []
    };
}
async function mt(e, t, n) {
  const { newPassword: r } = t, o = Ve.safeParse({
    newPassword: r,
    ...n
  });
  if (!o.success)
    throw new Error(o.error.errors.toString());
  const { error: i } = await e.resetPassword(o.data);
  if (i)
    throw new Error(i.errors.toString());
}
async function pt(e, t, n) {
  const { email: r } = t;
  try {
    await e.sendResetPasswordEmail(r, n);
  } catch (o) {
    console.error("sendResetPasswordEmail", o);
  }
}
async function ft(e) {
  try {
    const { success: t, error: n } = await e.logout();
  } catch {
  }
  return {
    customer: void 0
  };
}
async function Ct(e, t) {
  try {
    const { success: n, error: r } = await e.getCustomerData();
    return n ? {
      customer: t(n)
    } : {
      customer: void 0
    };
  } catch (n) {
    return console.error("fetchCustomer", n), {
      customer: void 0
    };
  }
}
async function yt(e, t, n) {
  var s, a, u, l, h, m, f;
  const { customer: r } = t, o = Object.fromEntries(
    Object.entries({
      firstName: (r == null ? void 0 : r.firstName) || "",
      lastName: (r == null ? void 0 : r.lastName) || "",
      address1: ((s = r == null ? void 0 : r.addresses[0]) == null ? void 0 : s.street) || "",
      address2: ((a = r == null ? void 0 : r.addresses[0]) == null ? void 0 : a.street2) || "",
      city: ((u = r == null ? void 0 : r.addresses[0]) == null ? void 0 : u.city) || "",
      state: ((l = r == null ? void 0 : r.addresses[0]) == null ? void 0 : l.state) || "",
      zipCode: ((h = r == null ? void 0 : r.addresses[0]) == null ? void 0 : h.zipCode) || "",
      country: ((m = r == null ? void 0 : r.addresses[0]) == null ? void 0 : m.country) || "",
      phoneNumber: ((f = r == null ? void 0 : r.addresses[0]) == null ? void 0 : f.phoneNumber) || ""
    }).filter(([p, b]) => b !== "")
  ), i = He.safeParse(
    o
  );
  if (!i.success)
    throw new Error(i.error.errors.toString());
  try {
    const { success: p, error: b } = await e.updateCustomerInfo(i.data);
    if (p) {
      if (!p.loggedIn)
        throw new Error("Unexpected response from register");
      return {
        customer: n(p.loggedIn)
      };
    } else
      throw b;
  } catch (p) {
    throw p;
  }
}
class kr {
  constructor(t, n, r) {
    this.client = t, this.mappers = n, this.options = r;
  }
  getToken() {
    var t;
    return (t = this.client.getTokenHandler()) == null ? void 0 : t.getToken();
  }
  async login(t) {
    return lt(
      this.client,
      t,
      this.mappers.customerMapper,
      this.options.onSelectionResponse
    );
  }
  async logout() {
    return ft(this.client);
  }
  async register(t) {
    return dt(
      this.client,
      t,
      this.mappers.customerMapper,
      this.options.onSelectionResponse
    );
  }
  async fetchOrders() {
    return ht(this.client, this.mappers.orderMapper);
  }
  async resetPassword(t) {
    return mt(this.client, t, this.options.resetPasswordData);
  }
  async sendResetPasswordEmail(t) {
    return pt(
      this.client,
      t,
      this.options.resetPasswordUri
    );
  }
  async fetchCustomer() {
    return Ct(this.client, this.mappers.customerMapper);
  }
  async updateCustomer(t) {
    return yt(this.client, t, this.mappers.customerMapper);
  }
}
class gt {
  constructor(t, n) {
    this.client = t, this.productMapper = n, this.search = async (r) => {
      const { success: o, error: i } = await this.client.getProducts({
        search: r.searchQuery,
        limit: r.limit
      });
      if (i)
        throw i;
      return {
        productSuggestions: o.products.map(
          (s) => this.productMapper(s)
        )
      };
    };
  }
}
d.object({
  market: d.string(),
  pricelist: d.string(),
  language: d.string(),
  site: d.object({
    baseUrl: d.string(),
    slug: d.string()
  }).optional()
});
const pe = O(
  void 0
);
function P() {
  const e = T(pe);
  if (!e)
    throw new Error("useCentraContext must be used within a CentraProvider");
  return e;
}
const Ar = (e) => {
  const { checkoutAPIClient: t, mappers: n } = P(), r = {
    autoCompleteClient: new gt(
      t,
      n.product
    )
  };
  return /* @__PURE__ */ c(Xe, { ...r, children: e.children });
};
class Sr {
  constructor(t, n) {
    this.client = t, this.defaultOptions = n;
  }
  createCentraOptions(t = {}) {
    const n = Ke.safeParse({
      ...this.defaultOptions,
      ...t
    });
    if (!n.success)
      throw new Error(
        `[CentraBackInStockClient]: Invalid input data for Centra back in stock, ${JSON.stringify(
          n.error.errors
        )}`
      );
    return n.data;
  }
  async subscribe(t) {
    await this.client.subscribeToBackInStock(
      t.email,
      t.subscribeItemId,
      this.createCentraOptions(t.attributes)
    );
  }
}
const fe = async (e, t) => {
  const n = [];
  if (e.length > 0) {
    const r = await Promise.all(
      e.map(async (o) => await t.getBundle({ id: o }))
    );
    for (const o of r)
      o.success && n.push(o.success);
  }
  return n;
}, wr = (e, t) => {
  const { checkoutAPIClient: n } = P(), [r, o] = y(!1), [i, s] = y(void 0), [a, u] = y(
    void 0
  );
  return E(() => {
    (async () => {
      if (!t)
        return;
      o(!0);
      const { success: h, error: m } = await n.getBundle({
        id: e
      });
      h ? s(h) : u(m), o(!1);
    })();
  }, [t, e]), {
    bundleResponse: i,
    loading: r,
    error: a
  };
};
class bt {
  constructor(t, n, r, o) {
    this.client = t, this.onSuccess = n, this.cartMapper = r, this.context = o, this.fetchCart = async () => this.client.getSelection().then(async (i) => await this.handleSelectionResponse(i)), this.addBundleToCart = async (i) => this.client.postBundle({
      item: i.itemId,
      sections: i.sections.map((s) => ({
        section: s.sectionId,
        item: s.itemId
      }))
    }).then(async (s) => await this.handleSelectionResponse(s)), this.addToCart = async (i) => {
      let s;
      return this.context.site && (s = `${this.context.site.baseUrl}/${this.context.site.slug}/${i.product.slug}`), this.client.postItem({
        itemId: i.itemId,
        quantity: i.quantity ?? 1,
        productUrl: s
      }).then(async (a) => await this.handleSelectionResponse(a));
    }, this.removeFromCart = async (i) => this.client.deleteItem({
      lineId: i.lineId,
      quantity: i.quantity
    }).then(async (s) => await this.handleSelectionResponse(s)), this.updateQuantity = async (i) => this.client.updateItem({
      lineId: i.lineId,
      quantity: i.quantity
    }).then(async (s) => await this.handleSelectionResponse(s)), this.updateComment = async () => {
      throw new Error("Not Implemented");
    }, this.addVoucher = async (i) => this.client.postVouchers(i.voucherCode).then((s) => this.handleSelectionResponse(s)), this.removeVoucher = async (i) => this.client.deleteVouchers(i.voucherCode).then((s) => this.handleSelectionResponse(s));
  }
  async handleSelectionResponse({
    success: t,
    error: n
  }) {
    if (t) {
      this.onSuccess(t);
      const r = t.selection.items.filter(
        (i) => {
          var s;
          return i.bundle && ((s = i.product.bundleInfo) == null ? void 0 : s.type) === "flexible";
        }
      ).map((i) => i.product.product), o = await fe(r, this.client);
      return this.cartMapper(t, o);
    }
    throw n;
  }
}
const Ce = O(
  void 0
), ye = O(void 0);
function ge() {
  const e = T(Ce);
  if (!e)
    throw new Error(
      "useCentraReducerState must be used within a CentraProvider"
    );
  return e;
}
function U() {
  const e = T(ye);
  if (!e)
    throw new Error(
      "useCentraReducerDispatch must be used within a CentraProvider"
    );
  return e;
}
function v() {
  return ge().selectionResponse;
}
const Pt = async (e, t) => {
  const n = e.items.filter(
    (r) => {
      var o;
      return !r.bundle && ((o = r.product.bundleInfo) == null ? void 0 : o.type) === "flexible";
    }
  ).map((r) => r.product.product);
  return fe(n, t);
}, be = (e) => {
  const { checkoutAPIClient: t, mappers: n, queryContext: r } = P(), { selectionResponse: o } = ge(), i = U(), [s, a] = y(void 0);
  E(() => {
    o && Pt(o.selection, t).then(
      (l) => {
        a(n.cart(o, l));
      }
    );
  }, [o]);
  const u = D(
    () => new bt(
      t,
      (l) => i({
        type: "SET_SELECTION_RESPONSE",
        payload: { selectionResponse: l }
      }),
      n.cart,
      r
    ),
    [t, n.cart]
  );
  return /* @__PURE__ */ c(ot, { initialCart: s, cartClientDriver: u, children: e.children });
};
be.displayName = "CentraGreaseCartProvider";
const vt = d.object({
  paymentReturnPage: d.custom(),
  paymentFailedPage: d.custom(),
  /**
   * This is a function that returns additional notes to be sent in the
   * POST payment request and ultimately stored on the Centra order.
   */
  additionalNotesGetter: d.function().args().returns(
    d.union([d.record(d.string(), d.unknown()), d.string(), d.undefined()])
  ).optional(),
  /**
   * This is a function that returns additional fields to be sent in the
   * payment fields update and payment requests.
   */
  additionalFieldsGetter: d.function().args().returns(d.union([d.record(d.string(), d.unknown()), d.undefined()])).optional(),
  visitorIpAddress: d.union([
    d.function().returns(d.promise(d.union([d.string().ip(), d.undefined()]))),
    d.string().ip()
  ]).optional()
}), $ = O(void 0), kt = (e) => /* @__PURE__ */ c($.Provider, { value: e.value, children: e.children }), Q = () => {
  const e = T($);
  if (!e)
    throw new Error(
      "useCentraCheckout must be used within CentraCheckoutProvider"
    );
  return e;
}, At = d.object({}), Nr = S(
  "CentraCheckoutError",
  g(At, (e) => null)
);
function St(e) {
  return e !== null && typeof e == "object" && "tagName" in e && e.tagName === "SCRIPT";
}
const wt = (e) => {
  var n, r;
  const t = document.createElement("script");
  t.text = e.innerHTML;
  for (let o = e.attributes.length - 1; o >= 0; o--) {
    const i = (n = e.attributes[o]) == null ? void 0 : n.name, s = (r = e.attributes[o]) == null ? void 0 : r.value;
    i && s && t.setAttribute(i, s);
  }
  return t;
}, Pe = (e) => {
  if (St(e))
    e.parentNode && e.parentNode.replaceChild(wt(e), e);
  else {
    const t = e.childNodes;
    for (const n of t)
      n && Pe(n);
  }
  return e;
}, ve = O(null), L = (e) => {
  const [t, n] = y(0), r = nt.count(e.children), o = t === r, i = he(() => {
    n((s) => s + 1);
  }, []);
  return /* @__PURE__ */ k(I, { children: [
    /* @__PURE__ */ c(ve.Provider, { value: i, children: e.children }),
    o && e.component
  ] });
}, Y = () => T(ve), F = (e) => {
  const t = Y(), n = G(null);
  return M(() => {
    t && t();
  }), E(() => {
    n.current && (n.current.innerHTML = e.html, Pe(n.current), e.onLoad && e.onLoad());
  }, [e.html]), /* @__PURE__ */ c("div", { style: { width: "100%" }, ref: n });
};
function J(e) {
  return e !== null && typeof e == "object" && "formHtml" in e && typeof e.formHtml == "string" && "action" in e && e.action === "form";
}
const ke = O(void 0);
function Z() {
  const e = T(ke);
  if (!e)
    throw new Error(
      "useCentraPaymentInitialize must be used within a CentraPaymentInitialize"
    );
  return e;
}
const Nt = () => /* @__PURE__ */ c("p", { children: "At least one shipping method must be configured in your Centra instance." }), Et = (e) => /* @__PURE__ */ c("li", { children: /* @__PURE__ */ k("label", { children: [
  e.loading && /* @__PURE__ */ c("span", { children: "Loading..." }),
  /* @__PURE__ */ c(
    "input",
    {
      type: "radio",
      id: e.methodKey,
      checked: e.isSelected,
      onChange: () => e.onChange(e.methodKey)
    }
  ),
  e.label,
  " (",
  e.price,
  ")"
] }) }), It = (e) => {
  var t;
  return /* @__PURE__ */ k("div", { children: [
    /* @__PURE__ */ c("label", { children: e.label }),
    /* @__PURE__ */ c(
      "input",
      {
        required: e.required,
        value: e.value || "",
        onChange: e.onChange
      }
    ),
    (t = e.messages) == null ? void 0 : t.map((n) => /* @__PURE__ */ c("p", { children: n }))
  ] });
}, Tt = (e) => {
  const [t, n] = y(!0), [r, o] = y(e.address), [i, s] = y(e.shippingAddress);
  function a() {
    const m = e.validateAddress({ address: r, shippingAddress: i });
    if (m === !0) {
      e.onUpdate({ address: r, shippingAddress: i });
      return;
    }
    o(m.address), s(m.shippingAddress);
  }
  const u = (m, f) => o((p) => ({
    ...p,
    [m]: {
      ...p[m],
      value: f.target.value
    }
  })), l = (m) => {
    var p, b;
    const f = r[m];
    if (f && f.validationResult !== !0 && ((b = (p = f.validationResult) == null ? void 0 : p.messages) != null && b.length))
      return f.validationResult.messages;
  }, h = [
    {
      label: "First Name",
      value: r.firstName.value,
      onChange: (m) => u("firstName", m),
      required: r.firstName.required,
      messages: l("firstName")
    },
    {
      label: "Last Name",
      value: r.lastName.value,
      onChange: (m) => u("lastName", m),
      required: r.lastName.required,
      messages: l("lastName")
    },
    {
      label: "Email",
      value: r.email.value,
      onChange: (m) => u("email", m),
      required: r.email.required,
      messages: l("email")
    },
    {
      label: "Street",
      value: r.street.value,
      onChange: (m) => u("street", m),
      required: r.street.required,
      messages: l("street")
    },
    {
      label: "Zip Code",
      value: r.zipCode.value,
      onChange: (m) => u("zipCode", m),
      required: r.zipCode.required,
      messages: l("zipCode")
    },
    {
      label: "City",
      value: r.city.value,
      onChange: (m) => u("city", m),
      required: r.city.required,
      messages: l("city")
    }
  ];
  return /* @__PURE__ */ c(I, { children: t ? /* @__PURE__ */ k("div", { children: [
    h.map((m) => /* @__PURE__ */ c(It, { ...m }, m.label)),
    /* @__PURE__ */ c("div", { children: /* @__PURE__ */ c("button", { onClick: a, children: "Update" }) })
  ] }) : /* @__PURE__ */ k(I, { children: [
    /* @__PURE__ */ k("div", { children: [
      /* @__PURE__ */ k("div", { children: [
        r.firstName.value,
        " ",
        r.lastName.value
      ] }),
      /* @__PURE__ */ c("div", { children: r.street.value }),
      /* @__PURE__ */ k("div", { children: [
        r.zipCode.value,
        " ",
        r.city.value
      ] }),
      /* @__PURE__ */ c("div", { children: r.country.selectedCountry.label })
    ] }),
    /* @__PURE__ */ c("button", { onClick: () => n(!0), children: "Edit" })
  ] }) });
}, Mt = (e) => /* @__PURE__ */ k("div", { children: [
  /* @__PURE__ */ c("h1", { children: "Select Shipping Method" }),
  /* @__PURE__ */ c("br", {}),
  e.children
] }), R = (e) => /* @__PURE__ */ c(I, { children: e.children }), _t = (e) => /* @__PURE__ */ k("div", { children: [
  /* @__PURE__ */ c("h1", { children: "Unavailable items" }),
  /* @__PURE__ */ c("ul", { children: e.unavailableItems.map((t) => /* @__PURE__ */ k("li", { children: [
    t.product.base.content.name,
    "is unavailable. You have ",
    t.availableQuantity,
    " available and",
    " ",
    t.unavailableQuantity,
    " was removed from cart."
  ] }, t.product.base.productId)) })
] }), Ot = () => /* @__PURE__ */ c("div", { children: "Payment method failed, reload checkout and try again. Make sure you're using HTTPS if you're in development mode." }), Ft = (e) => /* @__PURE__ */ c(I, { children: JSON.stringify(e.order) }), Rt = () => /* @__PURE__ */ c("div", { children: "Selection not found, go back to home" }), Dt = () => /* @__PURE__ */ c("p", { children: "Unsupported checkout flow, selected a specific one using props or configure Centra to only have one payment method per market." }), Ae = O(void 0), Bt = {
  ShippingMethodsNotConfigured: Nt,
  ShippingMethodOption: Et,
  AddressForm: Tt,
  ShippingMethods: Mt,
  QliroWrapper: R,
  AdyenDropInWrapper: R,
  KlarnaCheckoutWrapper: R,
  IngridWrapper: R,
  StandalonePaymentWrapper: R,
  YourCartHasBeenModified: _t,
  CartIsEmpty: () => null,
  CheckoutLoading: () => null,
  PaymentLoading: () => null,
  UnsupportedCheckoutFlow: Dt,
  UnsupportedPaymentMethod: () => null,
  UnsupportedShippingMethod: () => null,
  PaymentMethodFailed: Ot,
  SelectionNotFound: Rt,
  GenericOrderReceipt: Ft,
  FreeOrder: () => null
}, Gt = (e) => ({
  ...Bt,
  ...e
}), Se = ({
  value: e,
  children: t
}) => {
  const n = {
    components: Gt(e == null ? void 0 : e.components)
  };
  return /* @__PURE__ */ c(Ae.Provider, { value: n, children: t });
};
function A() {
  const e = T(Ae);
  if (!e)
    throw new Error(
      "useCentraCheckoutUiConfig must be used within a CentraCheckoutUiConfigProvider"
    );
  return e;
}
const qt = d.object({}), xt = g(
  qt,
  (e) => {
    const t = v(), n = Z(), [r, o] = y(null), [i, s] = y(0), a = G(null), {
      components: { KlarnaCheckoutWrapper: u }
    } = A();
    return E(() => {
      var h;
      if (!t)
        return;
      const l = (h = t.selection.pluginFields) == null ? void 0 : h.paymentHTML;
      l ? l !== a.current && (a.current = l, o(l), s((m) => m + 1)) : n && J(n) && o(n.formHtml);
    }, [t, n]), r === null ? null : /* @__PURE__ */ c(u, { children: /* @__PURE__ */ c(F, { html: r }, i) });
  }
), Lt = d.object({}), zt = g(
  Lt,
  () => {
    const e = v(), t = Z(), [n, r] = y(null), {
      components: { QliroWrapper: o }
    } = A();
    return E(() => {
      var i, s;
      e && (window.totalPrice = (i = e == null ? void 0 : e.selection) == null ? void 0 : i.totals.grandTotalPriceAsNumber, ((s = e == null ? void 0 : e.selection) == null ? void 0 : s.qliroReplaceSnippet) === !0 && e.selection.paymentHTML ? r(e.selection.paymentHTML) : t && J(t) && r(t.formHtml));
    }, [e]), n === null ? null : /* @__PURE__ */ c(o, { children: /* @__PURE__ */ c(F, { html: n }) });
  }
), jt = () => {
  const e = Z(), {
    components: { AdyenDropInWrapper: t }
  } = A();
  return !e || !J(e) ? null : /* @__PURE__ */ c(t, { children: /* @__PURE__ */ c(F, { html: e.formHtml }) });
}, we = () => {
  const e = v();
  return e == null ? void 0 : e.paymentMethods.find(
    (t) => t.paymentMethod === (e == null ? void 0 : e.selection.paymentMethod)
  );
}, Ut = "checkout_started_session", X = "add_shipping_info_session", Wt = "add_payment_info_session", W = ({
  sessionKey: e,
  prerequisiteKey: t
}) => {
  const n = G(!1);
  return { trackOnce: he(
    (o) => {
      if (n.current || t && !sessionStorage.getItem(t))
        return;
      if (sessionStorage.getItem(e)) {
        n.current = !0;
        return;
      }
      n.current = !0, sessionStorage.setItem(
        e,
        JSON.stringify({ timestamp: Date.now() })
      ), o();
    },
    [e, t]
  ) };
}, Ne = d.object({}), Ee = S(
  "CentraCheckoutPayment",
  g(Ne, (e) => {
    const t = j(), n = we(), r = v(), { mappers: o } = P(), {
      components: { UnsupportedPaymentMethod: i, CheckoutPaymentGate: s }
    } = A(), [a, u] = y(!1), { trackOnce: l } = W({
      sessionKey: Wt,
      prerequisiteKey: X
    });
    if (E(() => {
      !(n != null && n.paymentMethod) || !r || l(() => {
        t.eventEmitter.emit("paymentMethodSelected", {
          cart: o.cart(r, [])
        });
      });
    }, [n, r, l]), !n)
      return null;
    if (s && !a)
      return /* @__PURE__ */ c(s, { onSuccess: () => u(!0) });
    switch (n.paymentMethodType) {
      case "klarna_checkout":
        return /* @__PURE__ */ c(xt, {});
      case "qliro":
        return /* @__PURE__ */ c(zt, {});
      case "adyen_drop_in":
        return /* @__PURE__ */ c(jt, {});
      default:
        return /* @__PURE__ */ c(i, {});
    }
  })
), Vt = d.object({
  method: $e
}), Ht = g(
  Vt,
  ({ method: e }) => {
    const { checkoutAPIClient: t } = P(), n = U(), r = v(), [o, i] = y(!1), {
      components: { ShippingMethodOption: s }
    } = A();
    if (!r)
      return null;
    async function a(m) {
      i(!0);
      const { success: f, error: p } = await t.setShippingMethod({
        shippingMethod: m
      }).finally(() => i(!1));
      f ? n({
        type: "SET_SELECTION_RESPONSE",
        payload: { selectionResponse: f }
      }) : console.error(p);
    }
    const u = r.selection.shippingMethod === e.shippingMethod, h = !!r.selection.discounts.automaticDiscounts.find(
      (m) => {
        var f;
        return (f = m.freeShippingFor) == null ? void 0 : f.includes(e.shippingMethod);
      }
    );
    return /* @__PURE__ */ c(
      s,
      {
        methodKey: e.shippingMethod,
        label: e.name,
        loading: o,
        price: e.price,
        priceNumber: e.priceAsNumber,
        isSelected: u,
        onChange: a,
        isFreeShipping: h
      }
    );
  }
), Kt = d.object({}), $t = g(
  Kt,
  () => {
    const { mappers: e } = P(), t = j(), n = v(), r = Y(), {
      components: { ShippingMethods: o, ShippingMethodsNotConfigured: i }
    } = A(), { trackOnce: s } = W({
      sessionKey: X
    });
    M(() => {
      r && r();
    });
    const a = n == null ? void 0 : n.selection.shippingMethod;
    return E(() => {
      !a || !n || s(() => {
        t.eventEmitter.emit("shippingMethodSelected", {
          cart: e.cart(n)
        });
      });
    }, [a, n, s]), n ? n.shippingMethods.length === 0 ? /* @__PURE__ */ c(i, {}) : /* @__PURE__ */ c(o, { children: n.shippingMethods.map((u) => /* @__PURE__ */ c(
      Ht,
      {
        method: u
      },
      u.shippingMethod
    )) }) : null;
  }
), Qt = d.object({}), Yt = g(
  Qt,
  () => {
    var m, f;
    const e = j(), t = v(), { mappers: n } = P(), r = G(!1), { trackOnce: o } = W({
      sessionKey: X
    }), {
      components: { ShippingMethodsNotConfigured: i, IngridWrapper: s }
    } = A(), [a, u] = y(!0), l = ((m = t == null ? void 0 : t.selection.pluginFields) == null ? void 0 : m.ingrid) ?? // Ingrid V2
    ((f = t == null ? void 0 : t.selection.pluginFields) == null ? void 0 : f.shipwallet), h = (p, b) => {
      !t || !b.shipping_method_changed || o(() => {
        const w = {
          code: p.shipping_method,
          name: p.shipping_method
        };
        e.eventEmitter.emit("shippingMethodSelected", {
          cart: {
            ...n.cart(t),
            shippingMethod: w
          }
        });
      });
    };
    return E(() => {
      r.current || (r.current = !0, !(!(l != null && l.snippet) || !t || !window._sw) && window._sw(function(p) {
        p.on("data_changed", h);
      }));
    }, [l, t]), l != null && l.deliveryOptionsAvailable ? !a || !l.snippet ? null : /* @__PURE__ */ c(s, { children: /* @__PURE__ */ c(F, { html: l.snippet }) }) : /* @__PURE__ */ c(i, {});
  }
), Jt = () => {
  var n, r, o, i, s;
  const e = v();
  return ((s = ((r = (n = e == null ? void 0 : e.selection) == null ? void 0 : n.pluginFields) == null ? void 0 : r.ingrid) ?? ((i = (o = e == null ? void 0 : e.selection) == null ? void 0 : o.pluginFields) == null ? void 0 : i.shipwallet)) == null ? void 0 : s.deliveryOptionsAvailable) === !0 ? "ingrid" : "centra";
}, Zt = d.object({}), z = S(
  "CentraCheckoutShipping",
  g(Zt, () => {
    const e = Jt(), {
      components: { UnsupportedShippingMethod: t, CentraShippingMethodsRenderer: n }
    } = A(), r = n ?? $t;
    switch (e) {
      case "ingrid":
        return /* @__PURE__ */ c(Yt, {});
      case "centra":
        return /* @__PURE__ */ c(r, {});
      default:
        return /* @__PURE__ */ c(t, {});
    }
  })
), Ie = async (e, t) => {
  switch (e.action) {
    case "success": {
      const n = e == null ? void 0 : e.order, r = new CustomEvent("centra_checkout_payment_response", {
        detail: {
          action: null,
          resultCode: (n == null ? void 0 : n.resultCode) ?? null
        }
      });
      document.dispatchEvent(r);
      const o = window.location.href;
      setTimeout(() => {
        window.location.href === o && (window.location.href = t);
      }, 2e3);
      break;
    }
    case "redirect":
      e.url && (window.location.href = e.url);
      break;
    case "javascript": {
      const n = new CustomEvent("centra_checkout_payment_response", {
        detail: e.formFields
      });
      document.dispatchEvent(n);
      break;
    }
  }
};
async function se(e, t, n, r) {
  if (!n.detail)
    return;
  let o = {
    paymentMethodSpecificFields: n.detail.paymentMethodSpecificFields,
    paymentMethod: n.detail.paymentMethod
  };
  const s = {
    ...r == null ? void 0 : r(),
    ...n.detail.additionalFields
  };
  n.detail.addressIncluded && (o = {
    ...o,
    address: n.detail.billingAddress,
    shippingAddress: n.detail.shippingAddress,
    additionalFields: s
  });
  try {
    const { success: a, error: u } = await e(o);
    if (!a)
      throw u;
    Ie(a, t);
  } catch (a) {
    console.error(a);
  }
}
async function ae(e, t, n) {
  var s, a;
  if (!t.detail)
    return;
  const o = {
    ...n == null ? void 0 : n(),
    ...t.detail.additionalFields
  }, i = {
    ...t.detail,
    additionalFields: o
  };
  await e(i), (a = window.CentraCheckout) == null || a.resume((s = t.detail.additionalFields) == null ? void 0 : s.suspendIgnore);
}
const V = () => {
  const { checkoutAPIClient: e } = P(), t = Q(), n = v();
  function r(o, i) {
    return typeof o == "function" ? o(i) : o;
  }
  return async (o) => {
    if (n === void 0)
      throw new Error(
        "Selection not fetched, please verify your implementation"
      );
    const i = o ?? {};
    if (t.additionalNotesGetter) {
      const s = await t.additionalNotesGetter();
      if (typeof s == "string" && (i.additionalNotes = s), typeof s == "object" && s !== null)
        try {
          i.additionalNotes = JSON.stringify(s);
        } catch {
          console.error(
            "Failed to stringify additional notes for POST payment, not sending to Centra",
            { additionalNotes: s }
          );
        }
    }
    return t.visitorIpAddress && (typeof t.visitorIpAddress == "function" ? i.ipAddress = await t.visitorIpAddress().catch((s) => {
      console.error(
        "Failed to get visitor IP address for POST payment, sending undefined to Centra",
        { error: s }
      );
    }) : i.ipAddress = t.visitorIpAddress), await e.postPayment({
      paymentReturnPage: r(
        t.paymentReturnPage,
        n
      ),
      paymentFailedPage: r(
        t.paymentFailedPage,
        n
      ),
      address: n.selection.address,
      shippingAddress: n.selection.shippingAddress,
      ...i
    });
  };
}, Xt = () => {
  const e = T($);
  return D(() => {
    if (e != null && e.additionalFieldsGetter)
      return e.additionalFieldsGetter();
  }, [e == null ? void 0 : e.additionalFieldsGetter]);
}, Te = () => {
  const e = U(), { checkoutAPIClient: t } = P(), n = Xt();
  return async (r) => {
    const o = {
      ...r,
      additionalFields: {
        ...r.additionalFields ?? {},
        ...n
      }
    }, { success: i, error: s } = await t.paymentFieldsUpdate(o);
    if (i)
      return e({
        type: "SET_SELECTION_RESPONSE",
        payload: {
          selectionResponse: i
        }
      }), i;
    throw s;
  };
};
function H(e, t) {
  if (t === void 0)
    throw new Error("Selection not fetched, please verify your implementation");
  return typeof e == "function" ? e(t) : e;
}
function Me(e, t) {
  let n = {};
  t && t.selection && t.selection.totals ? n = {
    country: t.location.country,
    currency: t.selection.currency,
    currencyDenominator: t.selection.currencyFormat.denominator,
    grandTotalPriceAsNumber: t.selection.totals.grandTotalPriceAsNumber,
    shippingMethod: t.selection.shippingMethod,
    shippingMethodsAvailable: t.shippingMethods
  } : n = {
    error: !0
  };
  const r = new CustomEvent(e, {
    detail: n
  });
  document.dispatchEvent(r);
}
const ce = "centra_checkout_shipping_address_callback";
function en(e) {
  return async (t) => {
    if (!t.detail)
      return;
    const { shippingCountry: n, shippingState: r } = t.detail, { success: o, error: i } = await e.setCountry(
      n,
      r
    );
    if (i)
      throw new Error(
        `Couldn't set country to '${n}'${r ? `, or state to '${r}'` : ""}`
      );
    Me(
      "centra_checkout_shipping_address_response",
      o
    );
  };
}
const ue = "centra_checkout_shipping_method_callback";
function tn(e) {
  return async (t) => {
    if (!t.detail)
      return;
    const { shippingMethod: n } = t.detail, { success: r, error: o } = await e.setShippingMethod({
      shippingMethod: n
    });
    if (o)
      throw new Error(`Couldn't set shipping method to '${n}'`);
    Me(
      "centra_checkout_shipping_method_response",
      r
    );
  };
}
const _e = () => {
  const e = V(), t = Te(), n = v(), { checkoutAPIClient: r } = P(), { paymentReturnPage: o, additionalFieldsGetter: i } = Q(), s = n == null ? void 0 : n.selection.centraCheckoutScript;
  if (E(() => {
    var u, l;
    (u = window == null ? void 0 : window.CentraCheckout) == null || u.suspend(), (l = window == null ? void 0 : window.CentraCheckout) == null || l.resume();
  }, [n]), M(
    () => {
      document.addEventListener(
        "centra_checkout_payment_callback",
        (h) => se(
          e,
          H(o, n),
          h,
          i
        )
      ), document.addEventListener(
        "centra_checkout_callback",
        (h) => ae(
          t,
          h,
          i
        )
      );
      const u = en(r), l = tn(r);
      return document.addEventListener(
        ce,
        (h) => u(h)
      ), document.addEventListener(
        ue,
        (h) => l(h)
      ), () => {
        document.removeEventListener(
          "centra_checkout_payment_callback",
          (h) => se(
            e,
            H(o, n),
            h,
            i
          )
        ), document.removeEventListener(
          "centra_checkout_callback",
          (h) => ae(
            t,
            h,
            i
          )
        ), document.removeEventListener(
          ce,
          (h) => u(h)
        ), document.removeEventListener(
          ue,
          (h) => l(h)
        );
      };
    },
    { ifDefined: [s] }
  ), !n || !n.selection.centraCheckoutScript)
    return null;
  const a = `<script>${s}<\/script>`;
  return /* @__PURE__ */ c(F, { html: a });
}, le = (e, t) => {
  var s, a;
  const n = t.countries, r = t.location.country, o = e.country, i = n.find(
    (u) => u.country === o || u.country === r
  );
  if (!i)
    throw new Error("Country not found, this should not happen");
  return {
    email: { value: e.email, required: !0, validationResult: null },
    firstName: {
      value: e.firstName,
      required: !0,
      validationResult: null
    },
    lastName: {
      value: e.lastName,
      required: !0,
      validationResult: null
    },
    company: {
      value: e.company,
      required: !1,
      validationResult: null
    },
    street: {
      value: e.address1,
      required: !0,
      validationResult: null
    },
    zipCode: { value: e.zipCode, required: !0, validationResult: null },
    city: { value: e.city, required: !0, validationResult: null },
    country: {
      validationResult: null,
      selectedCountry: {
        label: i.name,
        value: i.country,
        stateRequired: !!((s = i.states) != null && s.length),
        selectedState: e.state ? {
          label: e.state,
          value: e.state
        } : void 0,
        states: (a = i.states) == null ? void 0 : a.map((u) => ({
          label: u.name,
          value: u.name
        }))
      },
      options: n.map((u) => {
        var l, h;
        return {
          label: u.name,
          value: u.country,
          stateRequired: !!((l = u.states) != null && l.length),
          states: (h = u.states) == null ? void 0 : h.map((m) => ({
            label: m.name,
            value: m.state
          }))
        };
      }),
      required: !0
    },
    phoneNumber: {
      value: e.phoneNumber,
      required: !0,
      validationResult: null
    },
    state: e.state ? { value: e.state, required: !0, validationResult: null } : void 0
  };
}, nn = (e) => {
  if (e.length === 0)
    return { messages: ["Checkout_Address_Phone_Number_Required"] };
  const t = /^[\d+\-()\s]+$/.test(e), n = /\d/.test(e);
  return t && n ? !0 : { messages: ["Checkout_Address_Invalid_Phone_Number"] };
}, rn = ({
  address: e,
  shippingAddress: t
}) => {
  var i, s;
  const n = {
    email: {
      ...e.email,
      validationResult: ie(e.email.value) ? !0 : { messages: ["Checkout_Address_Invalid_Email"] }
    },
    firstName: {
      ...e.firstName,
      validationResult: e.firstName.value.length > 0 ? !0 : { messages: ["Checkout_Address_First_Name_Required"] }
    },
    lastName: {
      ...e.lastName,
      validationResult: e.lastName.value.length > 0 ? !0 : { messages: ["Checkout_Address_Last_Name_Required"] }
    },
    street: {
      ...e.street,
      validationResult: e.street.value.length > 0 ? !0 : { messages: ["Checkout_Address_Address_Required"] }
    },
    phoneNumber: {
      ...e.phoneNumber,
      validationResult: nn(e.phoneNumber.value)
    },
    company: {
      ...e.company,
      validationResult: !0
    },
    country: {
      ...e.country,
      validationResult: !0
    },
    city: {
      ...e.city,
      validationResult: e.city.value.length > 0 ? !0 : { messages: ["Checkout_Address_City_Required"] }
    },
    zipCode: {
      ...e.zipCode,
      validationResult: e.zipCode.value.length > 0 ? !0 : { messages: ["Checkout_Address_Zip_Code_Required"] }
    },
    state: e.country.selectedCountry.stateRequired ? {
      value: ((i = e.state) == null ? void 0 : i.value) ?? "",
      required: !0,
      validationResult: ((s = e.state) == null ? void 0 : s.value) !== void 0 && e.state.value.length > 0 ? !0 : { messages: ["Checkout_Address_State_Required"] }
    } : void 0
  }, r = {
    email: {
      ...t.email,
      validationResult: ie(t.email.value) ? !0 : { messages: ["Checkout_Address_Invalid_Email"] }
    },
    firstName: {
      ...t.firstName,
      validationResult: t.firstName.value.length > 0 ? !0 : { messages: ["Checkout_Address_First_Name_Required"] }
    },
    lastName: {
      ...t.lastName,
      validationResult: t.lastName.value.length > 0 ? !0 : { messages: ["Checkout_Address_Last_Name_Required"] }
    },
    street: {
      ...t.street,
      validationResult: t.street.value.length > 0 ? !0 : { messages: ["Checkout_Address_Address_Required"] }
    },
    phoneNumber: {
      ...t.phoneNumber,
      validationResult: t.phoneNumber.value.length > 0 ? !0 : { messages: ["Checkout_Address_Phone_Number_Required"] }
    },
    company: {
      ...t.company,
      validationResult: !0
    },
    country: {
      ...t.country,
      validationResult: !0
    },
    city: {
      ...t.city,
      validationResult: t.city.value.length > 0 ? !0 : { messages: ["Checkout_Address_City_Required"] }
    },
    zipCode: {
      ...t.zipCode,
      validationResult: t.zipCode.value.length > 0 ? !0 : { messages: ["Checkout_Address_Zip_Code_Required"] }
    },
    state: t.state && {
      ...t.state,
      validationResult: !0
    }
  };
  return Object.values(r).every(
    (a) => a === void 0 || a.validationResult === !0
  ) && Object.values(n).every(
    (a) => a === void 0 || a.validationResult === !0
  ) ? !0 : {
    address: n,
    shippingAddress: r
  };
}, on = async ({
  address: e,
  shippingAddress: t,
  updatePaymentFields: n
}) => {
  var r, o;
  await n({
    shippingAddress: {
      email: t.email.value,
      firstName: t.firstName.value,
      lastName: t.lastName.value,
      address1: t.street.value,
      address2: "",
      // Not supported
      phoneNumber: t.phoneNumber.value,
      company: t.company.value,
      country: t.country.selectedCountry.value,
      city: t.city.value,
      zipCode: t.zipCode.value,
      state: (r = t.state) == null ? void 0 : r.value
    },
    address: {
      email: e.email.value,
      firstName: e.firstName.value,
      lastName: e.lastName.value,
      address1: e.street.value,
      address2: "",
      // Not supported
      phoneNumber: e.phoneNumber.value,
      company: e.company.value,
      country: e.country.selectedCountry.value,
      city: e.city.value,
      zipCode: e.zipCode.value,
      state: (o = e.state) == null ? void 0 : o.value
    }
  });
}, ee = d.object({
  onAddressUpdate: d.custom().optional()
}), Oe = S(
  "CheckoutAddressForm",
  g(ee, ({ onAddressUpdate: e }) => {
    const t = v(), n = Te(), {
      components: { AddressForm: r }
    } = A(), o = Y();
    if (M(() => {
      o && o();
    }), !t)
      return null;
    const i = async ({
      address: u,
      shippingAddress: l
    }) => {
      await on({
        address: u,
        shippingAddress: l,
        updatePaymentFields: n
      });
      try {
        e == null || e({ address: u, shippingAddress: l });
      } catch (h) {
        console.error(
          "Error calling onAddressUpdate in CheckoutAddressForm",
          h
        );
      }
    }, s = le(
      t.selection.address,
      t
    ), a = le(
      t.selection.shippingAddress,
      t
    );
    return /* @__PURE__ */ c(
      r,
      {
        address: s,
        shippingAddress: a,
        validateAddress: rn,
        onUpdate: i
      }
    );
  })
), te = (e) => {
  const t = v(), n = t == null ? void 0 : t.paymentMethods;
  if (!n)
    return null;
  const r = n.find(
    (o) => o.paymentMethod === e
  ) ?? n[0];
  return r ? !r.providesCustomerAddressAfterPayment : null;
}, Fe = (e) => {
  const t = te(e), n = v();
  if (!n)
    return !1;
  if (!t)
    return !0;
  const r = n.selection.shippingAddress;
  return [
    r.firstName,
    r.lastName,
    r.address1,
    r.zipCode,
    r.city,
    r.country
  ].every(Boolean);
};
function sn(e) {
  var t;
  return "errors" in e && ((t = e.errors) == null ? void 0 : t.selection) === "not found";
}
function Re(e) {
  var t;
  return "errors" in e && ((t = e.errors) == null ? void 0 : t.paymentMethod) === "failed";
}
function an(e) {
  var t;
  return "errors" in e && ((t = e.errors) == null ? void 0 : t.stock) === "unavailable_items" && "unavailableItems" in e;
}
const cn = ({
  error: e
}) => {
  var o;
  const { mappers: t } = P(), {
    components: { YourCartHasBeenModified: n, PaymentMethodFailed: r }
  } = A();
  return an(e) ? /* @__PURE__ */ c(
    n,
    {
      unavailableItems: ((o = e.unavailableItems) == null ? void 0 : o.map((i) => ({
        availableQuantity: i.available,
        unavailableQuantity: i.unavailable,
        originalQuantity: i.originalQuantity,
        product: t.product(i.product)
      }))) ?? []
    }
  ) : Re(e) ? /* @__PURE__ */ c(r, {}) : null;
};
async function De(e, t) {
  const { success: n, error: r } = await e.getSelection();
  if (n)
    t({
      type: "SET_SELECTION_RESPONSE",
      payload: {
        selectionResponse: n
      }
    });
  else
    throw r;
}
const un = () => {
  const e = U(), { checkoutAPIClient: t } = P();
  return () => De(t, e);
}, ne = d.object({
  children: d.custom(),
  paymentMethod: d.string().optional().describe(
    "The payment method uri to use instead of the one Centra pre-selects"
  )
}), Be = S(
  "CentraPaymentInitialize",
  g(ne, (e) => {
    const [t, n] = y(null), r = un(), o = V(), [i, s] = y(null), {
      components: { PaymentLoading: a }
    } = A();
    if (M(() => {
      async function u() {
        const l = {};
        e.paymentMethod && (l.paymentMethod = e.paymentMethod);
        const { success: h, error: m } = await o(l);
        h ? (await r(), n(h)) : s(m);
      }
      u();
    }), !t && !i)
      return /* @__PURE__ */ c(a, {});
    if (t)
      return /* @__PURE__ */ c(ke.Provider, { value: t, children: e.children });
    if (i)
      return /* @__PURE__ */ c(cn, { error: i });
  })
), Ge = () => {
  const e = v(), t = we();
  return (e == null ? void 0 : e.selection.totals.grandTotalPriceAsNumber) === 0 && (t == null ? void 0 : t.paymentMethodType) === "adyen_drop_in";
}, qe = () => {
  const e = V(), {
    components: { FreeOrder: t }
  } = A(), { paymentReturnPage: n } = Q(), r = v();
  return /* @__PURE__ */ c(t, { placeOrder: async () => {
    try {
      const { success: i, error: s } = await e();
      if (!i)
        throw s;
      Ie(
        i,
        H(n, r)
      );
    } catch (i) {
      console.error(i);
    }
  } });
}, xe = d.object({
  paymentInitialize: ne.optional(),
  checkoutAddressForm: ee.optional(),
  beforeContent: d.custom().optional(),
  afterContent: d.custom().optional()
}), ln = S(
  "CentraCheckoutSinglePaymentMethodFlow",
  g(xe, (e) => {
    var s;
    const t = (s = e.paymentInitialize) == null ? void 0 : s.paymentMethod, n = Fe(t), r = te(t), o = Ge(), i = /* @__PURE__ */ c(_e, {});
    return /* @__PURE__ */ k(I, { children: [
      e.beforeContent && /* @__PURE__ */ c(e.beforeContent, {}),
      r && /* @__PURE__ */ c(Oe, { ...e.checkoutAddressForm }),
      n && o && /* @__PURE__ */ k(I, { children: [
        /* @__PURE__ */ c(L, { component: i, children: /* @__PURE__ */ c(z, {}) }),
        /* @__PURE__ */ c(qe, {})
      ] }),
      n && !o && /* @__PURE__ */ c(Be, { ...e.paymentInitialize, children: /* @__PURE__ */ k(L, { component: i, children: [
        /* @__PURE__ */ c(z, {}),
        /* @__PURE__ */ c(Ee, {})
      ] }) }),
      e.afterContent && /* @__PURE__ */ c(e.afterContent, {})
    ] });
  })
), Le = d.object({
  paymentInitialize: ne.optional(),
  checkoutAddressForm: ee.optional(),
  beforeContent: d.custom().optional(),
  afterContent: d.custom().optional(),
  checkoutIsBlocked: d.boolean().optional()
}), dn = S(
  "CentraCheckoutSinglePageFlowWithBlocking",
  g(Le, (e) => {
    var u;
    const t = (u = e.paymentInitialize) == null ? void 0 : u.paymentMethod, n = Fe(t), r = te(t), o = Ge(), i = /* @__PURE__ */ c(_e, {}), s = e.checkoutIsBlocked ?? !1, a = n && !s;
    return /* @__PURE__ */ k(I, { children: [
      e.beforeContent && /* @__PURE__ */ c(e.beforeContent, {}),
      r && /* @__PURE__ */ c(Oe, { ...e.checkoutAddressForm }),
      /* @__PURE__ */ c(z, {}),
      a && o && /* @__PURE__ */ k(I, { children: [
        /* @__PURE__ */ c(L, { component: i, children: /* @__PURE__ */ c(z, {}) }),
        /* @__PURE__ */ c(qe, {})
      ] }),
      a && !o && /* @__PURE__ */ c(Be, { ...e.paymentInitialize, children: /* @__PURE__ */ c(L, { component: i, children: /* @__PURE__ */ c(Ee, {}) }) }),
      e.afterContent && /* @__PURE__ */ c(e.afterContent, {})
    ] });
  })
), ze = d.object({
  selectedPaymentMethod: Ne.optional(),
  singlePaymentMethodFlow: xe.optional(),
  singlePaymentMethodFlowWithBlocking: Le.optional()
}), hn = S(
  "CentraCheckoutFlow",
  g(ze, (e) => {
    const t = v(), {
      components: { CartIsEmpty: n, CheckoutLoading: r }
    } = A(), { mappers: o } = P(), i = j(), { trackOnce: s } = W({
      sessionKey: Ut
    });
    return M(
      () => {
        t && s(() => {
          i.eventEmitter.emit("checkoutStarted", {
            cart: o.cart(t, [])
          });
        });
      },
      { ifDefined: [t == null ? void 0 : t.selection] }
    ), t ? t.selection.items.length === 0 ? /* @__PURE__ */ c(n, {}) : e.singlePaymentMethodFlowWithBlocking ? /* @__PURE__ */ c(
      dn,
      {
        ...e.singlePaymentMethodFlowWithBlocking
      }
    ) : /* @__PURE__ */ c(ln, { ...e.singlePaymentMethodFlow }) : /* @__PURE__ */ c(r, {});
  })
), mn = d.object({
  paymentPages: vt,
  flow: ze.optional(),
  uiConfig: d.custom().optional(),
  checkoutEventEmitter: d.custom().optional()
}), pn = S(
  "CentraCheckout",
  g(mn, (e) => {
    const t = {
      eventEmitter: e.checkoutEventEmitter ?? st
    }, n = e.flow ?? {};
    return /* @__PURE__ */ c(at.Provider, { value: t, children: /* @__PURE__ */ c(kt, { value: e.paymentPages, children: /* @__PURE__ */ c(Se, { value: e.uiConfig, children: /* @__PURE__ */ c(
      hn,
      {
        selectedPaymentMethod: n.selectedPaymentMethod,
        singlePaymentMethodFlow: n.singlePaymentMethodFlow,
        singlePaymentMethodFlowWithBlocking: n.singlePaymentMethodFlowWithBlocking
      }
    ) }) }) });
  })
);
pn.displayName = "CentraCheckout";
const fn = ({
  error: e
}) => {
  const {
    components: { SelectionNotFound: t, PaymentMethodFailed: n }
  } = A();
  return sn(e) ? /* @__PURE__ */ c(t, {}) : Re(e) ? /* @__PURE__ */ c(n, {}) : null;
}, Cn = d.object({
  order: d.custom()
}), yn = S(
  "CentraCheckoutGenericReceipt",
  g(
    Cn,
    (e) => {
      const {
        components: { GenericOrderReceipt: t }
      } = A();
      return /* @__PURE__ */ c(t, { order: e.order });
    }
  )
), gn = d.object({
  order: d.custom(),
  paymentMethodData: d.custom()
}), bn = S(
  "CentraCheckoutSelectedReceipt",
  g(
    gn,
    (e) => {
      var n;
      const t = (n = e.paymentMethodData) == null ? void 0 : n.snippet;
      return t ? /* @__PURE__ */ c(F, { html: t }) : /* @__PURE__ */ c(yn, { order: e.order });
    }
  )
), Pn = d.object({
  postData: d.record(d.string(), d.unknown()).optional().describe(
    "Centra sends some data in the query string and some in the post body, this is the post body data"
  ),
  orderEventEmitter: d.custom().optional(),
  uiConfig: d.custom().optional()
}), Er = S(
  "CentraCheckoutFinalize",
  g(
    Pn,
    (e) => {
      const { checkoutAPIClient: t, mappers: n } = P(), [r, o] = y(null), [i, s] = y(null), [a, u] = y(null), { additionalData: l } = ct(), h = async (p) => {
        (e.orderEventEmitter ?? ut).emit("orderPlaced", {
          order: p,
          additionalData: l
        });
      }, m = async (p) => {
        const b = p.items.filter((C) => !!C.bundle).map((C) => C.product.product), w = [];
        if (b.length > 0) {
          const C = await Promise.all(
            b.map(
              (N) => t.getBundle({ id: N })
            )
          );
          for (const N of C)
            N.success && w.push(N.success);
        }
        return w;
      };
      M(() => {
        async function p() {
          const w = { ...Object.fromEntries(
            new URLSearchParams(location.search.replace(/^\?/, ""))
          ), ...e.postData };
          try {
            const { success: C, error: N } = await t.paymentResult({
              paymentMethodFields: w
            });
            if (C) {
              o(C);
              const x = await m(C.order), _ = n.order(C.order, x);
              s(_), h(_);
            }
            N && u(N);
          } catch (C) {
            console.error("Error finalizing Centra payment", C);
            return;
          }
        }
        p();
      });
      const f = () => r && i ? /* @__PURE__ */ c(
        bn,
        {
          order: i,
          paymentMethodData: r.order.paymentMethodData
        }
      ) : a ? /* @__PURE__ */ c(fn, { error: a }) : null;
      return /* @__PURE__ */ c(Se, { value: e.uiConfig, children: /* @__PURE__ */ c(f, {}) });
    }
  )
), vn = d.object({}), Ir = S(
  "CentraCheckoutPaypalCommerceButtonFlow",
  g(vn, (e) => /* @__PURE__ */ c("div", { children: "CentraCheckoutPaypalCommerceButtonFlow" }))
), kn = d.object({}), Tr = S(
  "CentraCheckoutStripePaymentIntentsFlow",
  g(kn, (e) => /* @__PURE__ */ c("div", { children: "CentraCheckoutStripePaymentIntentsFlow" }))
), Mr = ({
  paymentMethod: e
}) => {
  const [t, n] = y(null), r = V(), {
    components: { StandalonePaymentWrapper: o }
  } = A();
  return M(() => {
    const i = async () => {
      try {
        const s = await r({
          paymentMethod: e,
          paymentInitiateOnly: !0
        });
        s.success ? n(s.success) : console.error(
          `Payment initialization error for ${e}:`,
          s.error
        );
      } catch (s) {
        console.error(s);
      }
    };
    return i(), document.addEventListener(
      "centra_checkout_shipping_address_response",
      i
    ), () => {
      document.removeEventListener(
        "centra_checkout_shipping_address_response",
        i
      );
    };
  }), !t || t.action !== "form" ? null : /* @__PURE__ */ c(o, { children: /* @__PURE__ */ c(F, { html: t.formHtml }) });
}, An = (e) => {
  let t;
  try {
    t = JSON.parse(atob(e));
  } catch (n) {
    return console.error("error in parsing payload, invalid encoded string", n), window.location.href = "/", [];
  }
  return Array.isArray(t == null ? void 0 : t.i) ? t.i.map((n) => {
    const [r, o] = n;
    if (typeof r == "string" && typeof o == "number")
      return {
        item: r,
        quantity: o
      };
  }).filter((n) => typeof n < "u") : [];
}, _r = () => {
  const { checkoutAPIClient: e } = P(), t = it("fetchCart"), n = v();
  async function r(o) {
    await e.postItems(o), t.execute(void 0);
  }
  return M(
    () => {
      const o = new URLSearchParams(location.search);
      let i = [];
      const s = o.get("revive"), a = n == null ? void 0 : n.selection;
      if (typeof s == "string") {
        const u = An(s);
        if (!u || !u.length)
          return;
        if (a != null && a.items.length)
          for (const l of u) {
            const h = a == null ? void 0 : a.items.find(
              (m) => m.item === l.item
            );
            typeof h > "u" ? i.push({
              item: l.item,
              quantity: l.quantity
            }) : typeof (h == null ? void 0 : h.quantity) == "number" && h.quantity < l.quantity && i.push({
              item: l.item,
              quantity: l.quantity - h.quantity
            });
          }
        else
          i = u;
        i.length && r(i);
      }
    },
    { ifDefined: [e, n] }
  ), null;
}, Or = () => {
  throw new Error("not implemented");
}, Fr = d.enum([
  "klarna_checkout",
  "qliro",
  "adyen-drop-in"
]), Rr = d.enum(["centra", "ingrid"]);
function Sn(e, t) {
  switch (t.type) {
    case "SET_SELECTION_RESPONSE":
      return {
        ...e,
        selectionResponse: t.payload.selectionResponse
      };
    default:
      return e;
  }
}
function wn(e, t, n, r) {
  var i;
  const o = (i = e.items[0]) == null ? void 0 : i.item;
  if (!o)
    throw new Error("Bundle has no item id");
  return {
    dataModel: "bundle",
    itemId: o,
    preConfiguredBundle: e.bundleInfo.type === "fixed",
    base: r.centraCheckoutApiProductToGreaseProductBase(
      e,
      n,
      r
    ),
    bundlePurchaseInfo: r.centraCheckoutApiBundleToGreaseBundlePurchaseInfo(
      e,
      n
    ),
    sections: r.centraCheckoutApiBundleToGreaseBundleSections(
      e,
      t,
      n,
      r
    ),
    siblingProducts: []
  };
}
function Nn(e, { context: { currencyCode: t } }) {
  var o;
  const n = (o = e.items[0]) == null ? void 0 : o.stock, r = typeof n == "number" ? n : n === "yes" ? 1 : 0;
  return {
    sku: e.sku,
    inventory: {
      inStock: r > 0,
      warehouseId: "not-supported-yet",
      quantity: r
    },
    priceInfo: {
      price: {
        formatted: e.price,
        number: e.priceAsNumber
      },
      priceWithoutDiscount: {
        formatted: e.priceBeforeDiscount,
        number: e.priceBeforeDiscountAsNumber
      },
      previouslyDiscountedPrices: []
      // TODO: Implement previously discounted prices
    },
    additionalInventory: [],
    priceOfItemsOutsideBundle: {
      formatted: e.bundleInfo.priceOfItems,
      number: e.bundleInfo.priceOfItemsAsNumber
    },
    discountFromPriceOfItemsOutsideBundle: {
      formatted: Math.round(
        e.bundleInfo.priceOfItemsAsNumber - e.bundleInfo.priceMinAsNumber
      ) + " " + t,
      number: Math.round(
        e.bundleInfo.priceOfItemsAsNumber - e.bundleInfo.priceMinAsNumber
      )
    },
    priceMax: {
      formatted: e.bundleInfo.priceMax,
      number: e.bundleInfo.priceMaxAsNumber
    },
    priceMin: {
      formatted: e.bundleInfo.priceMin,
      number: e.bundleInfo.priceMinAsNumber
    }
  };
}
function En(e, t, n, r) {
  return e.bundleInfo.sections.map((o) => ({
    sectionId: o.section,
    quantity: o.quantity,
    products: o.products.map((i) => {
      const s = t.find(
        (a) => a.product === i.toString()
      );
      if (s)
        return r.centraCheckoutApiProductToGreaseProduct(
          s,
          n,
          r
        );
    }).filter(q)
  }));
}
function In(e, t, n, r) {
  return {
    dimensions: r.centraCheckoutApiProductItemToGreaseProductVariantDimensions(
      t,
      e,
      n
    ),
    label: t.name,
    mainProductId: e.product,
    mainProductKey: e.product,
    variantId: t.item,
    variantKey: t.item,
    outOfStockItemId: t.item,
    ...r.centraCheckoutApiItemToGreasePurchaseInfo(e, t)
  };
}
function Tn(e, t) {
  var i;
  const n = e.priceAsNumber !== e.priceBeforeDiscountAsNumber, r = Math.round(
    (1 - e.priceAsNumber / e.priceBeforeDiscountAsNumber) * 100
  ), o = typeof t.stock == "number" ? t.stock : t.stock === "yes" ? 1 : 0;
  return {
    sku: t.sku,
    inventory: {
      quantity: o,
      inStock: o > 0,
      warehouseId: "1"
    },
    additionalInventory: [],
    priceInfo: {
      price: { formatted: e.price, number: e.priceAsNumber },
      priceWithoutDiscount: {
        formatted: e.priceBeforeDiscount,
        number: e.priceBeforeDiscountAsNumber
      },
      previouslyDiscountedPrices: (i = e.lowestPrice) == null ? void 0 : i.map((s) => ({
        date: new Date(Date.now() - s.periodDays * 24 * 60 * 60 * 1e3),
        periodDays: s.periodDays,
        price: { formatted: s.price, number: s.priceAsNumber },
        priceWithoutDiscount: {
          formatted: s.priceBeforeDiscount,
          number: s.priceBeforeDiscountAsNumber
        }
      })),
      discountInfo: n ? {
        percent: r
      } : void 0
    }
  };
}
const Mn = (e, t, n, r) => {
  var o, i;
  return {
    orderNumber: e.order,
    currencyCode: e.currencyFormat.currency,
    status: r.centraCheckoutApiOrderStatusToGreaseOrderStatus(
      e.status
    ),
    date: new Date(e.date),
    additionalNotes: e.additionalNotes,
    paymentMethod: e.paymentMethodName,
    shippingMethod: e.shippingMethodName,
    itemQuantity: e.items.reduce((s, a) => s + a.quantity, 0) ?? 0,
    items: e.items.map(
      (s) => r.centraSelectionItemToGreaseLineItem(
        s,
        t,
        n,
        e.currencyFormat,
        r
      )
    ),
    totals: r.centraCheckoutApiOrderTotalsToGreaseOrderTotals(
      e.totals,
      e.items,
      e.currencyFormat
    ),
    billingAddress: r.centraCheckoutApiOrderAddressToGreaseOrderAddress(
      e.address
    ),
    shippingAddress: r.centraCheckoutApiOrderAddressToGreaseOrderAddress(
      e.shippingAddress
    ),
    vouchers: ((i = (o = e.discounts) == null ? void 0 : o.vouchers) == null ? void 0 : i.map(
      (s) => r.centraCheckoutApiVoucherToGreaseCodeVoucher(s)
    )) ?? []
  };
}, _n = (e) => e ? {
  firstName: e.firstName ?? "",
  lastName: e.lastName ?? "",
  email: e.email ?? "",
  street: e.address1 ?? "",
  zipCode: e.zipCode ?? "",
  city: e.city ?? "",
  country: e.country ?? "",
  state: e.state ?? "",
  phoneNumber: e.phoneNumber ?? ""
} : {
  firstName: "",
  lastName: "",
  email: "",
  street: "",
  zipCode: "",
  city: "",
  country: "",
  state: "",
  phoneNumber: ""
};
function On(e) {
  switch (e) {
    case "untouched":
      return "pending";
    case "progress":
      return "processing";
    case "ok":
      return "completed";
    case "archived":
    case "failed":
      return "cancelled";
  }
  throw new Error(`Unknown order status: ${e}`);
}
const Fn = (e, t, n) => {
  if (n.productOptions.itemDimensionParser)
    return n.productOptions.itemDimensionParser(e);
  const r = e.name.split(t.itemTable.dividerSymbol), o = (a, u) => r.length === 1 ? "size" : a.replace(/[^\d\w]+/g, "_") + "_" + u, i = (a) => r.length === 1 ? e.item : a, s = (a) => r.length === 1 ? e.name : a;
  return r.map((a, u) => ({
    value: i(a),
    valueLabel: s(a),
    dimensionKey: o(t.itemTable.desc, u),
    dimensionLabel: o(t.itemTable.desc, u)
  }));
}, Rn = (e, t, n, r) => {
  if (e.bundleInfo) {
    const o = t.find(
      (i) => i.bundle.product === e.product
    );
    return o ? r.centraCheckoutApiBundleToGreaseBundle(
      o.bundle,
      o.sectionProducts,
      n,
      r
    ) : (console.error(
      `Bundle "${e.product}" has no bundle info, cannot create product`
    ), r.centraCheckoutApiProductToGreaseProduct(
      e,
      n,
      r
    ));
  }
  return r.centraCheckoutApiProductToGreaseProduct(
    e,
    n,
    r
  );
};
function Dn(e, t, n) {
  return e.items.length === 1 ? n.centraCheckoutApiProductToGreaseProductSimple(
    e,
    t,
    n
  ) : n.centraCheckoutApiProductToGreaseProductWithVariants(
    e,
    t,
    n
  );
}
function Bn(e, t) {
  return [];
}
function Gn(e, t, n) {
  var o;
  let r = e.uri;
  if (t.productOptions.uriField) {
    const i = e[t.productOptions.uriField];
    typeof i == "string" && i.length > 0 && (r = i);
  }
  return {
    productId: e.product,
    productKey: e.sku,
    slug: r,
    discontinued: !1,
    content: n.centraCheckoutApiProductToGreaseProductContent(
      e,
      t,
      n
    ),
    attributes: n.centraCheckoutApiProductToGreaseProductExtraAttributes(e),
    categories: ((o = e.categories) == null ? void 0 : o.map((i) => ({
      categoryId: i.category,
      categoryKey: i.category,
      name: i.name.join(" / "),
      slug: i.uri
    }))) ?? []
  };
}
function qn(e, t, n) {
  return {
    name: e.name,
    description: e.description,
    shortDescription: e.excerpt,
    media: n.centraCheckoutApiProductToGreaseProductMedia(
      e,
      t
    ),
    badges: n.centraCheckoutApiProductToGreaseProductBadges(
      e,
      t
    ),
    // Centra also has uri and ID for this, maybe we should support that?
    brand: e.brandName ?? void 0
  };
}
function xn(e) {
  const t = {
    attributeKey: "product_color",
    attributeLabel: "Order_Summary_Color_Label",
    value: e.variantName,
    valueLabel: e.variantName
  }, n = {
    attributeKey: "tableMappings",
    attributeLabel: "tableMappings",
    value: e.tableMappings ?? {},
    valueLabel: "tableMappings"
  };
  return [...Object.keys(e).filter((o) => !Qe.shape.hasOwnProperty(o)).filter(
    (o) => !Ye.shape.hasOwnProperty(o)
  ).reduce((o, i) => [
    ...o,
    {
      attributeKey: i,
      attributeLabel: i,
      value: e[i],
      valueLabel: `${e[i]}`
      // Centra doesn't support value labels for attributes
    }
  ], []).filter((o) => o.value !== void 0), t, n];
}
function Ln(e, t) {
  var r;
  const n = (r = e.media) == null ? void 0 : r[t.productOptions.productImageKey];
  return n ? n.map((o, i) => {
    var s, a, u, l;
    return {
      type: "image",
      src: o,
      alt: ((a = (s = e.mediaObjects) == null ? void 0 : s[i]) == null ? void 0 : a.altText) || e.name,
      attributes: Object.entries(((l = (u = e.mediaObjects) == null ? void 0 : u[i]) == null ? void 0 : l.attributes) ?? {}).map(
        ([h, m]) => ({
          attributeKey: h,
          attributeLabel: h,
          value: m,
          valueLabel: `${m}`
        })
      ) || []
    };
  }) : e.mediaUrls ? e.mediaUrls.map((o, i) => {
    var s, a, u, l;
    return {
      type: "image",
      src: o,
      alt: ((a = (s = e.mediaObjects) == null ? void 0 : s[i]) == null ? void 0 : a.altText) || e.name,
      attributes: Object.entries(((l = (u = e.mediaObjects) == null ? void 0 : u[i]) == null ? void 0 : l.attributes) ?? {}).map(
        ([h, m]) => ({
          attributeKey: h,
          attributeLabel: h,
          value: m,
          valueLabel: `${m}`
        })
      ) || []
    };
  }) : (console.warn(
    `No media found for product ${e.product}. This is likely a misconfiguration.`
  ), []);
}
const zn = (e, t, n) => {
  var r;
  return ((r = e.relatedProducts) == null ? void 0 : r.map((o) => {
    if (o.relation === "variant")
      return n.centraCheckoutApiProductToGreaseProductBase(
        o,
        t,
        n
      );
  }).filter(q)) ?? [];
};
function jn(e, t, n, r) {
  const { selection: o, token: i } = e, s = o.discounts.vouchers.map(
    (a) => r.centraCheckoutApiVoucherToGreaseCodeVoucher(a)
  ).concat(
    o.discounts.automaticDiscounts.map(
      (a) => r.centraCheckoutApiAutoVoucherToGreaseAutoVoucher(a)
    )
  ) ?? [];
  return {
    cartId: i,
    currencyCode: o.currency,
    languageCode: o.language,
    vouchers: s,
    paymentMethod: {
      code: o.paymentMethod,
      name: o.paymentMethodName
    },
    shippingMethod: {
      code: o.shippingMethod,
      name: o.shippingMethodName
    },
    items: o.items.map(
      (a) => r.centraSelectionItemToGreaseLineItem(
        a,
        t,
        n,
        o.currencyFormat,
        r
      )
    ),
    totals: r.centraSelectionToGreaseCartTotals(
      o.totals,
      o.items,
      // required to calculate subtotal
      o.currencyFormat
    )
  };
}
const Un = (e) => ({
  id: e.customer,
  firstName: e.firstName,
  lastName: e.lastName,
  email: e.email,
  addresses: [
    {
      firstName: e.firstName,
      lastName: e.lastName,
      street: e.address1,
      street2: e.address2,
      city: e.city,
      state: e.state,
      zipCode: e.zipCode,
      country: e.country,
      phoneNumber: e.phoneNumber
    }
  ],
  attributes: {}
});
function Wn(e, t) {
  return t > 0 ? Math.trunc(e) : Math.round(e);
}
function B(e, t) {
  if (!t)
    return "";
  const n = parseInt(t.decimalDigits ?? "0"), r = e % 1, o = Wn(e, n).toString().replace(/\B(?=(\d{3})+(?!\d))/g, t.thousandsSeparator ?? " "), i = n > 0 ? `${t.decimalPoint}${String(
    Math.round(r * Math.pow(10, n))
  ).padStart(n, "0")}` : "";
  return `${t.prefix}${o}${i}${t.suffix}`;
}
function Vn(e, t, n, r, o) {
  var f;
  let i, s;
  const a = parseInt(r.decimalDigits ?? "0"), u = Math.pow(10, a), l = Math.round(
    u * (e.totalPriceAfterDiscountAsNumber / e.quantity)
  ) / u;
  l === 0 ? (s = {
    number: e.totalPriceAsNumber,
    formatted: e.totalPrice
  }, i = {
    number: e.priceEachAsNumber,
    formatted: e.priceEach
  }) : (s = {
    number: e.totalPriceAfterDiscountAsNumber,
    formatted: e.totalPriceAfterDiscount
  }, i = {
    number: l,
    formatted: B(l, r)
  });
  const h = {
    lineId: e.line,
    id: e.item,
    quantity: e.quantity,
    sku: e.sku,
    price: {
      discounted: typeof e.priceEachBeforeDiscountAsNumber == "number",
      priceEach: i,
      priceEachWithoutDiscount: {
        number: e.priceEachBeforeDiscountAsNumber,
        formatted: e.priceEachBeforeDiscount
      },
      priceEachWithoutTax: {
        number: e.priceEachWithoutTaxAsNumber,
        formatted: e.priceEachWithoutTax
      },
      totalPrice: s
    }
  }, m = (p) => {
    if (!Array.isArray(p))
      return;
    const b = t.find(
      (C) => C.bundle.product === e.product.product
    );
    if (!b) {
      console.warn(
        `Bundle "${e.product.product}" has no bundle info, cannot create product, cart item will be a product instead`
      );
      return;
    }
    const w = o.centraCheckoutApiBundleToGreaseBundle(
      b.bundle,
      b.sectionProducts,
      n,
      o
    );
    return {
      type: "bundle",
      bundleItems: p.map((C) => {
        const N = w.sections.flatMap((_) => _.products).find((_) => _.base.productId === C.product);
        let x;
        return N && (x = N.base.content.media.find(
          (_) => _.type === "image"
        )), {
          id: C.product,
          name: C.productName,
          quantity: C.quantity,
          image: x,
          price: {
            discounted: C.priceEachBeforeDiscountAsNumber > C.priceEachAsNumber,
            priceEach: {
              number: C.priceEachAsNumber,
              formatted: C.priceEach
            },
            priceEachWithoutDiscount: {
              number: C.priceEachBeforeDiscountAsNumber,
              formatted: C.priceEachBeforeDiscount
            },
            priceEachWithoutTax: {
              number: C.priceEachWithoutTaxAsNumber,
              formatted: C.priceEachWithoutTax
            },
            totalPrice: {
              number: C.totalPriceAsNumber,
              formatted: C.totalPrice
            }
          },
          itemDimensions: [
            {
              value: C.size,
              valueLabel: C.size,
              dimensionKey: "size",
              dimensionLabel: "size"
            }
          ]
        };
      }),
      ...h,
      product: w
    };
  };
  if (Array.isArray(e.bundle) && ((f = e.product.bundleInfo) == null ? void 0 : f.type) === "flexible") {
    const p = m(e.bundle);
    if (p)
      return p;
  }
  return {
    type: "product",
    ...h,
    itemDimensions: [
      {
        value: e.size,
        valueLabel: e.size,
        dimensionKey: "size",
        dimensionLabel: "size"
      }
    ],
    product: o.centraCheckoutApiProductToGreaseProduct(
      e.product,
      n,
      o
    )
  };
}
function Hn(e, t, n) {
  let r;
  typeof e.taxAddedAsNumber == "number" && typeof e.taxAdded == "string" ? r = {
    number: e.taxAddedAsNumber,
    formatted: e.taxAdded
  } : r = {
    number: e.grandTotalPriceTaxAsNumber,
    formatted: e.grandTotalPriceTax
  };
  const o = t.reduce((a, u) => {
    const h = u.totalPriceAfterDiscountAsNumber === 0 ? 0 : u.priceEachAsNumber * u.quantity;
    return a + h;
  }, 0), i = t.reduce(
    (a, u) => a + u.priceEachWithoutTaxAsNumber * u.quantity,
    0
  );
  let s;
  return typeof e.totalDiscountPriceAsNumber == "number" && typeof e.totalDiscountPrice == "string" && (s = {
    number: e.totalDiscountPriceAsNumber,
    formatted: e.totalDiscountPrice
  }), {
    grandTotal: {
      number: e.grandTotalPriceAsNumber,
      formatted: e.grandTotalPrice
    },
    shipping: {
      number: e.shippingPriceAsNumber,
      formatted: e.shippingPrice
    },
    subtotalWithoutTax: {
      number: i,
      formatted: B(
        i,
        n
      )
    },
    subtotal: {
      number: o,
      formatted: B(o, n)
    },
    discount: s,
    tax: r
  };
}
function Kn(e, t, n) {
  const r = e.items[0], o = n.centraCheckoutApiProductToGreaseProductBase(
    e,
    t,
    n
  ), i = n.centraCheckoutApiRelatedProductsToSiblingProducts(
    e,
    t,
    n
  );
  return {
    dataModel: "simple",
    isBundle: e.bundleInfo !== void 0,
    base: o,
    siblingProducts: i,
    itemId: r.item,
    outOfStockItemId: r.item,
    ...n.centraCheckoutApiItemToGreasePurchaseInfo(e, r)
  };
}
function $n(e, t, n) {
  const r = n.centraCheckoutApiProductToGreaseProductBase(
    e,
    t,
    n
  ), o = n.centraCheckoutApiRelatedProductsToSiblingProducts(
    e,
    t,
    n
  );
  return {
    dataModel: "with_variants",
    base: r,
    siblingProducts: o,
    variants: e.items.map(
      (i) => n.centraCheckoutApiItemToGreaseProductVariant(
        e,
        i,
        t,
        n
      )
    ).filter((i) => !!i)
  };
}
const Qn = (e) => ({
  type: "auto",
  name: e.name,
  affectsOrderTotal: e.hasAffectedOrder,
  discount: {
    number: e.priceOffAsNumber,
    formatted: e.priceOff
  }
}), Yn = (e) => ({
  type: "code",
  code: e.voucher,
  name: e.description,
  affectsOrderTotal: e.hasAffectedOrder,
  discount: {
    number: e.priceOffAsNumber,
    formatted: e.priceOff
  }
});
function Jn(e, t, n) {
  const r = t.reduce(
    (s, a) => s + a.priceEachWithoutTaxAsNumber * a.quantity,
    0
  ), o = t.reduce((s, a) => {
    const l = a.totalPriceAfterDiscountAsNumber === 0 ? 0 : a.priceEachAsNumber * a.quantity;
    return s + l;
  }, 0);
  let i;
  return typeof e.totalOriginalDiscountPriceAsNumber == "number" && typeof e.totalOriginalDiscountPrice == "string" && (i = {
    number: e.totalOriginalDiscountPriceAsNumber,
    formatted: e.totalOriginalDiscountPrice
  }), {
    grandTotal: {
      number: e.grandTotalPriceAsNumber,
      formatted: e.grandTotalPrice
    },
    shipping: {
      number: e.shippingPriceAsNumber,
      formatted: e.shippingPrice
    },
    subtotalWithoutTax: {
      number: r,
      formatted: B(
        r,
        n
      )
    },
    subtotal: {
      number: o,
      formatted: B(o, n)
    },
    discount: i,
    tax: {
      number: e.grandTotalPriceTaxAsNumber,
      formatted: e.grandTotalPriceTax
    }
  };
}
const re = {
  centraCheckoutApiBundleToGreaseBundlePurchaseInfo: Nn,
  centraCheckoutApiBundleToGreaseBundleSections: En,
  centraCheckoutApiBundleToGreaseBundle: wn,
  centraCheckoutApiItemToGreaseProductVariant: In,
  centraCheckoutApiItemToGreasePurchaseInfo: Tn,
  centraCheckoutApiOrderAddressToGreaseOrderAddress: _n,
  centraCheckoutApiOrderStatusToGreaseOrderStatus: On,
  centraCheckoutApiOrderToGreaseOrder: Mn,
  centraCheckoutApiProductToGreaseItemProduct: Rn,
  centraCheckoutApiProductToGreaseProductBase: Gn,
  centraCheckoutApiProductToGreaseProductContent: qn,
  centraCheckoutApiProductToGreaseProductMedia: Ln,
  centraCheckoutApiProductToGreaseProduct: Dn,
  centraCheckoutApiRelatedProductsToSiblingProducts: zn,
  centraCheckoutApiSelectionToGreaseCart: jn,
  centraCheckoutApiCustomerToGreaseCustomer: Un,
  centraSelectionItemToGreaseLineItem: Vn,
  centraSelectionToGreaseCartTotals: Hn,
  centraCheckoutApiOrderTotalsToGreaseOrderTotals: Jn,
  centraCheckoutApiProductToGreaseProductExtraAttributes: xn,
  centraCheckoutApiProductItemToGreaseProductVariantDimensions: Fn,
  centraCheckoutApiProductToGreaseProductBadges: Bn,
  centraCheckoutApiProductToGreaseProductWithVariants: $n,
  centraCheckoutApiProductToGreaseProductSimple: Kn,
  centraCheckoutApiAutoVoucherToGreaseAutoVoucher: Qn,
  centraCheckoutApiVoucherToGreaseCodeVoucher: Yn
};
function Zn(e, t = {}) {
  const n = { ...re, ...t };
  return function(o, i = []) {
    var s;
    if (((s = o.bundleInfo) == null ? void 0 : s.type) === "flexible" && i.length) {
      const a = i.find(
        (u) => u.bundle.product === o.product
      );
      if (a)
        return n.centraCheckoutApiBundleToGreaseBundle(
          a.bundle,
          a.sectionProducts,
          e,
          n
        );
      console.error(`Bundle "${o.product}" missing; falling back.`);
    }
    return n.centraCheckoutApiProductToGreaseProduct(
      o,
      e,
      n
    );
  };
}
function Xn(e, t = {}) {
  const n = { ...re, ...t };
  return function(o, i = []) {
    return n.centraCheckoutApiOrderToGreaseOrder(
      o,
      i,
      e,
      n
    );
  };
}
function er(e, t = {}) {
  const n = { ...re, ...t };
  return function(o, i = []) {
    return n.centraCheckoutApiSelectionToGreaseCart(
      o,
      i,
      e,
      n
    );
  };
}
const tr = (e) => {
  var u, l, h;
  const [t, n] = rt(Sn, {}), r = Zn(
    (u = e.mapperOptions) == null ? void 0 : u.options,
    e.mapperOptions.mappers
  ), o = er(
    (l = e.mapperOptions) == null ? void 0 : l.options,
    e.mapperOptions.mappers
  ), i = Xn(
    (h = e.mapperOptions) == null ? void 0 : h.options,
    e.mapperOptions.mappers
  ), s = {
    checkoutAPIClient: e.checkoutAPIClient,
    queryContext: e.queryContext,
    mappers: {
      product: r,
      cart: o,
      order: i
    }
  }, a = G(!1);
  return E(() => {
    async function m() {
      if (!a.current)
        return a.current = !0, De(e.checkoutAPIClient, n);
    }
    const f = e.initializationType || "onLoad";
    f === "onLoad" && m(), f === "onInteraction" && console.error("CentraProvider: 'onInteraction' not implemented yet");
  }, [e.initializationType]), /* @__PURE__ */ c(pe.Provider, { value: s, children: /* @__PURE__ */ c(Ce.Provider, { value: t, children: /* @__PURE__ */ c(ye.Provider, { value: n, children: /* @__PURE__ */ c(be, { children: e.children }) }) }) });
};
tr.displayName = "CentraProvider";
class Dr {
  constructor(t, n) {
    this.client = t, this.defaultOptions = n;
  }
  createOptions(t = {}) {
    const n = Je.safeParse({
      ...this.defaultOptions,
      ...t
    });
    if (!n.success)
      throw new Error(
        `[CentraNewsletterClient]: Invalid input data for Centra newsletter, ${JSON.stringify(
          n.error.errors
        )}`
      );
    return n.data;
  }
  async subscribe(t) {
    await this.client.subscribeToNewsletter(
      t.email,
      this.createOptions(t.attributes)
    );
  }
  async unsubscribe(t) {
    throw new Error(
      "[CentraNewsletterClient]: Unsubscribe method not implemented"
    );
  }
}
const je = O(void 0), nr = (e) => {
  const t = D(
    () => ({
      searchFunctionGetter: e.searchFunctionGetter
    }),
    [e.searchFunctionGetter]
  );
  return /* @__PURE__ */ c(je.Provider, { value: t, children: e.children });
};
nr.displayName = "CentraSearchProvider";
const rr = (e, t, n, r) => (e === "items.name" && (r != null && r.length) && t.sort((o, i) => {
  if (typeof o.data != "string" || typeof i.data != "string")
    return 0;
  const s = r.indexOf(o.data), a = r.indexOf(i.data);
  return s === -1 && a === -1 ? 0 : s === -1 ? 1 : a === -1 ? -1 : s - a;
}), t.map(({ data: o, count: i = 0 }) => {
  let s, a, u;
  if (typeof o == "string")
    a = s = o;
  else if (typeof o == "object" && o !== null) {
    if (e === "swatch.desc" && typeof o.desc == "string" && typeof o.hex == "string")
      s = o.desc, u = o.hex, a = o.desc;
    else if (e === "brands") {
      if (!(o != null && o.brand))
        return;
      a = o.brand;
    } else if (e === "categories") {
      if (!(o != null && o.category))
        return;
      a = o.category;
    }
    typeof o.name == "string" ? s = o.name : Array.isArray(o.name) && (s = o.name.join(" / "));
  } else {
    console.error("Unknown Centra filter data type", o);
    return;
  }
  if (!a || !s)
    return;
  const l = n.includes(a), h = !(l || i > 0);
  return { name: s, selected: l, disabled: h, count: i, id: a, hex: u };
}).filter(q));
function or(e) {
  return Object.keys(e).filter(
    (t) => t !== "limit" && t !== "skipFirst" && t !== "sortOrder"
  ).filter((t) => {
    const n = e[t];
    return me(n) && n.length > 0;
  });
}
const ir = (e, t, n, r) => {
  if (!e)
    return [];
  const o = or(n);
  return e.filter(({ values: i }) => i && i.length > 0).map(({ field: i, values: s }) => {
    if (!i || !s || o.includes(i))
      return;
    const a = me(t[i]) ? t[i] : [], u = s.filter(
      (l) => l.filterCount && l.filterCount > 0
    );
    if (!(u.length <= 1))
      return {
        name: i,
        id: i,
        type: "checkbox",
        selectedCount: a.length,
        values: rr(
          i,
          u,
          a,
          r
        )
      };
  }).filter(q);
}, oe = (e) => {
  const { checkoutAPIClient: t } = P(), n = T(je), r = K(), { mappers: o } = P();
  return n != null && n.searchFunctionGetter ? n.searchFunctionGetter(e) : async (i) => {
    const s = {
      limit: r.defaultItemsPerPage,
      // Set default limit if not provided in payload
      ...i
    }, { success: a } = await t.getProducts(s);
    if (!a || !a.products)
      return de;
    const u = a.productCount ?? 0, h = (s.skipFirst ?? 0) / s.limit + 1, m = {
      itemsPerPage: s.limit,
      totalItems: u,
      totalPages: Math.ceil(u / s.limit),
      currentPage: h
    }, f = a.products.map((b) => ({
      type: "product",
      product: o.product(b)
    })).filter(q), p = ir(
      a.filter,
      s,
      e
    );
    return {
      items: f,
      meta: m,
      facets: p,
      sort: []
      // Not yet supported
    };
  };
}, Ue = (e, t) => {
  let n = e;
  return t.forEach((r) => {
    if (r.type !== "checkbox")
      return;
    const o = r.values.filter((i) => i.selected);
    n = {
      ...n,
      [r.id]: o.map((i) => i.id)
    };
  }), n;
}, sr = (e) => {
  const t = oe(e), n = K();
  return async (r, o) => {
    if (!o)
      return [];
    let i = {
      ...e,
      skipFirst: (r - 1) * (e.limit ?? n.defaultItemsPerPage)
    };
    return i = Ue(
      i,
      o.facets
    ), (await t(i)).items;
  };
}, ar = (e) => {
  const t = oe(e);
  return async (n) => {
    let r = {
      ...e,
      skipFirst: 0
      // Always reset pagination when changing facets
    };
    return r = Ue(
      r,
      n
    ), await t(r);
  };
}, cr = d.object({
  payload: Ze.extend({
    limit: d.union([d.number().int().default(20), d.string().default("20")]).optional()
  }),
  children: d.custom()
}), Br = S(
  "CentraSearchResultsProvider",
  g(
    cr,
    (e) => {
      const t = K(), n = et(), { queryContext: r } = P(), o = e.payload.limit ? Number(e.payload.limit) : t.defaultItemsPerPage, i = {
        ...e.payload,
        skipFirst: (n - 1) * o,
        limit: o
      }, s = oe(i), a = sr(i), u = ar(i), l = D(
        () => ({
          initialPayload: i,
          queryContext: r
        }),
        [i, r]
      ), h = D(
        () => ({
          fetchSearchResult: async () => await s(i),
          loadPage: a,
          setFacets: u,
          setSortOrder: async () => Promise.resolve(de)
        }),
        [s, i, a, u]
      );
      return /* @__PURE__ */ c(
        tt,
        {
          queryParams: l,
          searchMethods: h,
          children: e.children
        }
      );
    }
  )
);
export {
  Wt as ADD_PAYMENT_INFO_SESSION_KEY,
  X as ADD_SHIPPING_INFO_SESSION_KEY,
  Tt as AddressForm,
  ce as CENTRA_CHECKOUT_SHIPPING_ADDRESS_CALLBACK_EVENT_NAME,
  ue as CENTRA_CHECKOUT_SHIPPING_METHOD_CALLBACK_EVENT_NAME,
  Ut as CHECKOUT_STARTED_SESSION_KEY,
  kr as CentraAccountClient,
  gt as CentraAutoCompleteClient,
  Ar as CentraAutoCompleteProvider,
  Sr as CentraBackInStockClient,
  bt as CentraCartClientDriver,
  pn as CentraCheckout,
  Nr as CentraCheckoutError,
  Er as CentraCheckoutFinalize,
  fn as CentraCheckoutFinalizeError,
  hn as CentraCheckoutFlow,
  qe as CentraCheckoutFreeOrder,
  yn as CentraCheckoutGenericReceipt,
  F as CentraCheckoutHtml,
  jt as CentraCheckoutPaymentAdyenDropIn,
  xt as CentraCheckoutPaymentKlarnaCheckout,
  zt as CentraCheckoutPaymentQliro,
  Ir as CentraCheckoutPaypalCommerceButtonFlow,
  kt as CentraCheckoutProvider,
  _e as CentraCheckoutScript,
  Ee as CentraCheckoutSelectedPaymentMethod,
  bn as CentraCheckoutSelectedReceipt,
  z as CentraCheckoutSelectedShippingMethod,
  $t as CentraCheckoutShippingCentra,
  Ht as CentraCheckoutShippingCentraOption,
  Yt as CentraCheckoutShippingIngrid,
  ln as CentraCheckoutSinglePageFlow,
  dn as CentraCheckoutSinglePageFlowWithBlocking,
  Tr as CentraCheckoutStripePaymentIntentsFlow,
  Se as CentraCheckoutUiConfigProvider,
  be as CentraGreaseCartProvider,
  Dr as CentraNewsletterClient,
  Be as CentraPaymentInitialize,
  tr as CentraProvider,
  _r as CentraReviveCart,
  nr as CentraSearchProvider,
  Br as CentraSearchResultsProvider,
  Mr as CentraStandalonePaymentButton,
  Oe as CheckoutAddressForm,
  Ft as GenericOrderReceipt,
  cn as PaymentInitializeError,
  Ot as PaymentMethodFailed,
  R as PaymentWrapper,
  L as RenderAfterChildren,
  Rt as SelectionNotFound,
  Et as ShippingMethodOption,
  Mt as ShippingMethods,
  Nt as ShippingMethodsNotConfigured,
  Dt as UnsupportedPaymentMethodFlow,
  _t as YourCartHasBeenModified,
  Qn as centraCheckoutApiAutoVoucherToGreaseAutoVoucher,
  wn as centraCheckoutApiBundleToGreaseBundle,
  Nn as centraCheckoutApiBundleToGreaseBundlePurchaseInfo,
  En as centraCheckoutApiBundleToGreaseBundleSections,
  Un as centraCheckoutApiCustomerToGreaseCustomer,
  In as centraCheckoutApiItemToGreaseProductVariant,
  Tn as centraCheckoutApiItemToGreasePurchaseInfo,
  _n as centraCheckoutApiOrderAddressToGreaseOrderAddress,
  On as centraCheckoutApiOrderStatusToGreaseOrderStatus,
  Mn as centraCheckoutApiOrderToGreaseOrder,
  Jn as centraCheckoutApiOrderTotalsToGreaseOrderTotals,
  Fn as centraCheckoutApiProductItemToGreaseProductVariantDimensions,
  Rn as centraCheckoutApiProductToGreaseItemProduct,
  Dn as centraCheckoutApiProductToGreaseProduct,
  Bn as centraCheckoutApiProductToGreaseProductBadges,
  Gn as centraCheckoutApiProductToGreaseProductBase,
  qn as centraCheckoutApiProductToGreaseProductContent,
  xn as centraCheckoutApiProductToGreaseProductExtraAttributes,
  Ln as centraCheckoutApiProductToGreaseProductMedia,
  Kn as centraCheckoutApiProductToGreaseProductSimple,
  $n as centraCheckoutApiProductToGreaseProductWithVariants,
  zn as centraCheckoutApiRelatedProductsToSiblingProducts,
  Vn as centraCheckoutApiSelectionItemToGreaseLineItem,
  jn as centraCheckoutApiSelectionToGreaseCart,
  Hn as centraCheckoutApiSelectionToGreaseCartTotals,
  Yn as centraCheckoutApiVoucherToGreaseCodeVoucher,
  ae as centraCheckoutCallback,
  $ as centraCheckoutContext,
  vt as centraCheckoutContextSchema,
  At as centraCheckoutErrorSchema,
  Pn as centraCheckoutFinalizeSchema,
  ze as centraCheckoutFlowSchema,
  Cn as centraCheckoutGenericReceiptSchema,
  se as centraCheckoutPaymentCallback,
  qt as centraCheckoutPaymentKlarnaCheckoutSchema,
  Lt as centraCheckoutPaymentQliroSchema,
  vn as centraCheckoutPaypalCommerceButtonFlowSchema,
  mn as centraCheckoutSchema,
  Ne as centraCheckoutSelectedPaymentMethodSchema,
  gn as centraCheckoutSelectedReceiptSchema,
  Zt as centraCheckoutSelectedShippingMethodSchema,
  Vt as centraCheckoutShippingCentraOptionSchema,
  Kt as centraCheckoutShippingCentraSchema,
  Qt as centraCheckoutShippingIngridSchema,
  Le as centraCheckoutSinglePageFlowWithBlockingSchema,
  xe as centraCheckoutSinglePaymentMethodFlowSchema,
  kn as centraCheckoutStripePaymentIntentsFlowSchema,
  Ae as centraCheckoutUiConfigContext,
  pe as centraContext,
  De as centraFetchSelection,
  ir as centraFiltersToGreaseFacets,
  ne as centraPaymentInitializeSchema,
  Fr as centraPaymentMethodType,
  Sn as centraReducer,
  ye as centraReducerDispatch,
  Ce as centraReducerState,
  je as centraSearchContext,
  cr as centraSearchResultsProviderSchema,
  Rr as centraShippingMethodType,
  ee as checkoutAddressFormSchema,
  en as createCentraCheckoutShippingAddressCallback,
  tn as createCentraCheckoutShippingMethodCallback,
  re as defaultCentraCheckoutApiMappers,
  fe as fetchBundlesByIds,
  Ct as fetchCustomer,
  ht as fetchOrders,
  B as formatCentraPrice,
  An as getCartPayloadFromUrlPart,
  H as getPaymentPage,
  Ie as handlePostPaymentAction,
  sn as isCentraFinalizeSelectionNotFoundError,
  Re as isCentraPaymentFailedError,
  an as isCentraPaymentUnavailableItemsError,
  J as isFormResponse,
  lt as login,
  ft as logout,
  Xn as makeCentraCheckoutApiOrderToGreaseOrderMapper,
  Zn as makeCentraCheckoutApiProductToGreaseProductMapper,
  er as makeCentraCheckoutApiSelectionToGreaseCartMapper,
  le as mapCentraAddressFieldToGreaseCheckoutFields,
  rr as mapFacetValues,
  ke as paymentInitializeContext,
  dt as register,
  Pe as replaceScriptNode,
  mt as resetPassword,
  Ue as searchResultFacetsToCentraGetProductsPayload,
  Me as sendCentraShippingUpdateEvent,
  pt as sendResetPasswordEmail,
  on as updateCentraAddressFields,
  yt as updateCustomer,
  Xt as useAdditionalPaymentFields,
  Fe as useCentraAddressIsValid,
  wr as useCentraBundleResponse,
  Q as useCentraCheckout,
  A as useCentraCheckoutUiConfig,
  te as useCentraCheckoutUsesAddressForm,
  P as useCentraContext,
  un as useCentraFetchSelection,
  Ge as useCentraIsFreeOrder,
  Or as useCentraPaymentAction,
  Z as useCentraPaymentInitialize,
  V as useCentraPostPayment,
  U as useCentraReducerDispatch,
  ge as useCentraReducerState,
  oe as useCentraSearchFunction,
  sr as useCentraSearchLoadPage,
  ar as useCentraSearchSetFacets,
  we as useCentraSelectedPaymentMethod,
  Jt as useCentraSelectedShippingMethodType,
  v as useCentraSelectionResponse,
  Te as useCentraUpdatePaymentFields,
  Y as useRenderAfterChildren,
  W as useTrackOnce,
  rn as validateCheckoutAddresses
};
//# sourceMappingURL=lib.es.js.map
